// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IGetProjectsListMetaResponseSchema } from '../../entities/v1_entities/GetProjectsListMetaResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetProjectsListMetaRequest {
  /** Идентификатор региона **/
  regionId?: number;
  /** Цена от **/
  priceFrom?: number;
  /** Цена до **/
  priceTo?: number;
  /** Площадь от **/
  areaFrom?: number;
  /** Площадь до **/
  areaTo?: number;
  /** Этажность **/
  floors?: EFloors[];
  /** Материалы **/
  materials?: EMaterials[];
}
export enum EFloors {
  /** Один **/
  'One' = 'one',
  /** Три и более **/
  'ThreeAndMore' = 'threeAndMore',
  /** Два **/
  'Two' = 'two',
}
export enum EMaterials {
  /** Блоки **/
  'Blocks' = 'blocks',
  /** Кирпич **/
  'Brick' = 'brick',
  /** Каркасные дома **/
  'FrameHouses' = 'frameHouses',
  /** Клееный брус **/
  'GluedLaminatedTimber' = 'gluedLaminatedTimber',
  /** Монолит **/
  'Monolith' = 'monolith',
  /** Другое **/
  'Other' = 'other',
  /** СИП технологии **/
  'Sip' = 'sip',
  /** Цельное дерево (бревно или брус) **/
  'SolidTree' = 'solidTree',
}

export type IGetProjectsListMetaResponse = IGetProjectsListMetaResponseSchema;

export interface IGetProjectsListMetaResponse200 extends IModelResponse<IGetProjectsListMetaResponse> {
  statusCode: 200;
}

export type IGetProjectsListMetaResponseError = IErrorResponseSchema;

export interface IGetProjectsListMetaResponse400 extends IModelResponse<IGetProjectsListMetaResponseError> {
  statusCode: 400;
}

export type TGetProjectsListMetaResponse = IGetProjectsListMetaResponse200 | IGetProjectsListMetaResponse400;

export type TGetProjectsListMetaModel = IModel<IGetProjectsListMetaRequest, TGetProjectsListMetaResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetProjectsListMetaResponse): TResponse200;
  400(response: IGetProjectsListMetaResponseError): TResponse400;
}
